<section class="bg-white intro">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 px-0 termekek">
        <section class="bg-white text-primary mt-5 mb-4 py-4">
          <div class="container pt-5">
            <div class="row pt-4">
              <div class="col-12 col-lg-10">
                <h1 class="bold">KÖZZÉTÉTELEK</h1>
              </div>
            </div>
          </div>
        </section>
        <section class="bg-white mb-4 py-4 article-section">
          <div class="container">
            <div class="row justify-content-center">
              <div class="ps-4 pe-4">

                <div class="col-lg-12 mt-5 pt-3">
                  <div class="accordion rounded-4 mb-3" id="accordionGranit">
                    <div class="accordion-item bg-light">
                      <h2 class="accordion-header ">
                        <button class="accordion-button bg-info text-primary bold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                          BIT. 108/A. § (1) BEKEZDÉSE SZERINTI KÖZZÉTÉTELEK
                        </button>
                      </h2>
                      <div id="collapse1" class="accordion-collapse collapse" data-bs-parent="#accordionGranit">
                        <div class="accordion-body accordion-shadow-lg text-light">
                          <div class="small">
                            <ul>
                              <li><a class="download" target="_blank" href="{{weboldalDokumentumok}}H-JE-II-B-26_2016.pdf">H-JÉ-II-B-26/2016. számú határozat</a></li>
                              <li><a class="download" target="_blank" href="{{weboldalDokumentumok}}H-JE-II-B-5_2017.pdf">H-JÉ-II-B-5/2017. számú határozat</a></li>
                              <li><a class="download" target="_blank" href="{{weboldalDokumentumok}}H-JE-II-B-10_2020.pdf">H-JÉ-II-B-10/2020. számú határozat</a></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="accordion-item bg-light">
                      <h2 class="accordion-header ">
                        <button class="accordion-button bg-info text-primary bold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                          FIZETŐKÉPESSÉGRŐL ÉS PÉNZÜGYI HELYZETRŐL SZÓLÓ JELENTÉSEK
                        </button>
                      </h2>
                      <div id="collapse2" class="accordion-collapse collapse" data-bs-parent="#accordionGranit">
                        <div class="accordion-body accordion-shadow-lg text-light">
                          <div class="small">
                            <ul>
                              <li><a class="download" target="_blank" href="{{weboldalDokumentumok}}fizetokepesseg_penzugyi_helyzet_2016.pdf">Fizetőképességről és pénzügyi helyzetről szóló jelentés 2016.</a></li>
                              <li><a class="download" target="_blank" href="{{weboldalDokumentumok}}fizetokepesseg_penzugyi_helyzet_2017.pdf">Fizetőképességről és pénzügyi helyzetről szóló jelentés 2017.</a></li>
                              <li><a class="download" target="_blank" href="{{weboldalDokumentumok}}fizetokepesseg_penzugyi_helyzet_2018.pdf">Fizetőképességről és pénzügyi helyzetről szóló jelentés 2018.</a></li>
                              <li><a class="download" target="_blank" href="{{weboldalDokumentumok}}fizetokepesseg_penzugyi_helyzet_2019.pdf">Fizetőképességről és pénzügyi helyzetről szóló jelentés 2019.</a></li>
                              <li><a class="download" target="_blank" href="{{weboldalDokumentumok}}fizetokepesseg_penzugyi_helyzet_2020.pdf">Fizetőképességről és pénzügyi helyzetről szóló jelentés 2020.</a></li>
                              <li><a class="download" target="_blank" href="{{weboldalDokumentumok}}fizetokepesseg_penzugyi_helyzet_2021.pdf">Fizetőképességről és pénzügyi helyzetről szóló jelentés 2021.</a></li>
                              <li><a class="download" target="_blank" href="{{weboldalDokumentumok}}fizetokepesseg_penzugyi_helyzet_2022.pdf">Fizetőképességről és pénzügyi helyzetről szóló jelentés 2022.</a></li>
                              <li><a class="download" target="_blank" href="{{weboldalDokumentumok}}fizetokepesseg_penzugyi_helyzet_2023.pdf">Fizetőképességről és pénzügyi helyzetről szóló jelentés 2023.</a></li>
                              <li><a class="download" target="_blank" href="{{weboldalDokumentumok}}fizetokepesseg_penzugyi_helyzet_2024.pdf">Fizetőképességről és pénzügyi helyzetről szóló jelentés 2024.</a></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="accordion-item bg-light">
                      <h2 class="accordion-header ">
                        <button class="accordion-button bg-info text-primary bold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                          FIZETŐKÉPESSÉGRŐL ÉS PÉNZÜGYI HELYZETRŐL SZÓLÓ CSOPORTSZINTŰ JELENTÉSEK
                        </button>
                      </h2>
                      <div id="collapse3" class="accordion-collapse collapse" data-bs-parent="#accordionGranit">
                        <div class="accordion-body accordion-shadow-lg text-light">
                          <div class="small">
                            <ul>
                              <li><a class="download" target="_blank" href="{{weboldalDokumentumok}}fizetokepesseg_penzugyi_helyzet_csoportszintu_2024.pdf">Fizetőképességről és pénzügyi helyzetről szóló csoportszintű jelentés 2024.</a></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</section>
